import { Box, Button, Tooltip } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {
  getTestNurturingJourneyResultStatus,
} from "app/utils/nurturingTestAutomationProgressUtils";

interface CellButtonWithResultStatusProps {
  params: any;
  onClick: (params: any, clickedElement?: string) => void;
  children: React.ReactNode;
}

const CellButtonWithResultStatus = ({
  params,
  onClick,
  children,
}: CellButtonWithResultStatusProps) => {
  const status = getTestNurturingJourneyResultStatus(
    params?.row?.messages_sent_count,
    params?.row?.expected_sent_count,
  );
  const isSuccess = status === "success";
  const tooltipTitle = isSuccess
    ? "Nurturing automation success"
    : "Nurturing automation failed";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
      <Button
        variant="text"
        size="small"
        tabIndex={params?.hasFocus ? 0 : -1}
        sx={{
          width: "fit-content",
          color: "text.primary",
          textDecoration: "underline",
          textTransform: "none",
          fontSize: "14px",
          justifyContent: "flex-start",
          minWidth: 0,
        }}
        onClick={(e) => {
          e.stopPropagation();
          onClick(params);
        }}
      >
        {children}
      </Button>

      <Tooltip title={tooltipTitle} arrow placement="top">
        <Box
          sx={(theme) => ({
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 18,
            height: 18,
            borderRadius: "50%",
            color: theme.palette.common.white,
            backgroundColor: isSuccess
              ? theme.palette.success.main
              : theme.palette.error.main,
            flexShrink: 0,
          })}
        >
          {isSuccess ? (
            <CheckRoundedIcon sx={{ fontSize: 14 }} />
          ) : (
            <CloseRoundedIcon sx={{ fontSize: 14 }} />
          )}
        </Box>
      </Tooltip>
    </Box>
  );
};

export default CellButtonWithResultStatus;
